import { createAsyncThunk } from '@reduxjs/toolkit';

import { auth } from 'src/app/database';
import api from 'src/app/apiSingleton';

export const getBrokerDashboardData = createAsyncThunk(
  'broker-dashboard/get-broker-dashboard-data',
  async (data, thunkApi) => {
    try {
      const { isAgency = false, org_id, broker_id } = data;

      const token = await auth.currentUser.getIdToken();

      api.apiClient.setToken(token);

      if (isAgency) {
        const agencyAccountsResponse = await api.agency.getAgencyAccounts({ 'f[org_id]': org_id });
        const agencyProposalsResponse = await api.agency.getAgencyProposalsList({
          'f[org_id]': org_id,
        });

        return {
          accounts: agencyAccountsResponse?.meta?.total || 0,
          proposals: agencyProposalsResponse?.meta?.total || 0,
        };
      }

      const brokerAccountsResponse = await api.broker.getBrokerAccounts({
        'f[broker_id]': broker_id,
      });
      const brokerProposalsResponse = await api.broker.getProposalsList({
        'f[broker_id]': broker_id,
      });

      return {
        accounts: brokerAccountsResponse?.meta?.total || 0,
        proposals: brokerProposalsResponse?.meta?.total || 0,
      };
    } catch (err) {
      console.warn(err);
    }
  },
);
